// Cache for variant availability to avoid redundant API calls
const variantAvailabilityCache = new Map();

const observer = new MutationObserver(() => {
    document.querySelectorAll(".vw--text-button").forEach((btn) => {
        if (!btn.dataset.listenerAttached) {
            btn.dataset.listenerAttached = "true";

            // Check availability on page load
            checkProductAvailability(btn);

            btn.addEventListener('click', async (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                const dataVideowiseVariantId = btn.getAttribute("data-videowise-variant-id");

                if (!dataVideowiseVariantId) return;

                // If button is converted to "Choose Options", navigate to PDP
                if (btn.dataset.chooseOptions === 'true') {
                    window.location.href = btn.dataset.productUrl;
                    return;
                }

                // Show loading state
                const originalText = btn.textContent;
                btn.disabled = true;
                btn.textContent = 'Adding...';

                try {
                    const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({
                            items: [{
                                id: Number(dataVideowiseVariantId),
                                quantity: 1
                            }],
                        }),
                    });

                    const addResponseJson = await addResponse.json();

                    // Check if the response indicates an error (out of stock)
                    if (!addResponse.ok || addResponseJson.status === 422 || addResponseJson.description) {
                        await convertToChooseOptions(btn);
                        return;
                    }

                    // Reset button state on success
                    btn.disabled = false;
                    btn.textContent = originalText;

                    // Open cart drawer
                    const cartDrawerElement = document.querySelector("cart-drawer") || document.querySelector("side-drawer[data-name='cart-drawer']");
                    if (cartDrawerElement) {
                        await cartDrawerElement.refresh(true);
                        setTimeout(() => {
                            cartDrawerElement.open();
                        }, 500);
                    }
                } catch (error) {
                    console.error('Videowise: Error adding to cart', error);
                    // Reset button on error
                    btn.disabled = false;
                    btn.textContent = originalText;
                }
            }, true);
        }
    });
});

// Check product availability on page load (optimized with caching)
async function checkProductAvailability(btn) {
    const variantId = btn.getAttribute("data-videowise-variant-id");
    if (!variantId) return;

    // Check cache first to avoid redundant API calls
    if (variantAvailabilityCache.has(variantId)) {
        const cachedData = variantAvailabilityCache.get(variantId);
        if (!cachedData.available) {
            await convertToChooseOptions(btn, cachedData.url);
        }
        return;
    }

    try {
        const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);

        if (!response.ok) {
            // Variant doesn't exist, cache it and try to convert button
            variantAvailabilityCache.set(variantId, { available: false, url: '' });
            await convertToChooseOptions(btn, '');
            return;
        }

        const variant = await response.json();
        const productUrl = variant.url ? variant.url.split('?')[0] : '';

        // Cache both availability and URL
        variantAvailabilityCache.set(variantId, {
            available: variant.available,
            url: productUrl
        });

        if (!variant.available) {
            await convertToChooseOptions(btn, productUrl);
        }
    } catch (error) {
        // Silently handle errors - variant might not exist or network issue
        variantAvailabilityCache.set(variantId, { available: false, url: '' });
        await convertToChooseOptions(btn, '');
    }
}

// Convert button to "Choose Options" and link to PDP
async function convertToChooseOptions(btn, productUrl = '') {
    const variantId = btn.getAttribute("data-videowise-variant-id");

    // If productUrl not provided, try to fetch it
    if (!productUrl && variantId) {
        try {
            const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);
            if (response.ok) {
                const variant = await response.json();
                productUrl = variant.url ? variant.url.split('?')[0] : '';
            }
        } catch (error) {
            // Silently handle fetch errors
        }
    }

    // If still no productUrl, try to find the product link in the Videowise widget
    if (!productUrl) {
        // Look for the Videowise inline shoppable product container
        const container = btn.closest('.vw--inline-shoppable-product');

        if (container) {
            // Find the product title link
            const titleLink = container.querySelector('.vw--inline-shoppable-product--content--title');
            if (titleLink && titleLink.href) {
                productUrl = titleLink.href.split('?')[0];
            }
        }
    }

    // Update button to show "Choose Options" with link to PDP
    if (productUrl) {
        btn.textContent = 'Choose Options';
        btn.disabled = false;
        btn.dataset.chooseOptions = 'true';
        btn.dataset.productUrl = productUrl;
    } else {
        // Last resort - just disable the button
        btn.textContent = 'Out of Stock';
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
    }
}

observer.observe(document.body, {
    childList: true,
    subtree: true
});